import { render, staticRenderFns } from "./dashboard-performance-rank.vue?vue&type=template&id=e0df21ae&scoped=true&"
import script from "./dashboard-performance-rank.vue?vue&type=script&lang=js&"
export * from "./dashboard-performance-rank.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-performance-rank.vue?vue&type=style&index=0&id=e0df21ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0df21ae",
  null
  
)

export default component.exports